import User from './UserStore';
import CompaniesStore from './CompaniesStore';
import GroupsStore from './GroupsStore';
import MeetingsStore from './MeetingStore';
import VotesStore from './VoteStore';
import DocumentStore from './DocumentStore';
import WARStore from './WARStore';
import AlertStore from './AlertStore';
import ConnectionStore from './ConnectionStore';
import TasksStore from './TasksStore';

class Store {
    constructor() {
        this.initialise();
    }

    initialise() {
        // console.log('store clear');
        this.user = new User(this);
        this.companies = new CompaniesStore(this);
        this.groups = new GroupsStore(this);
        this.meetings = new MeetingsStore(this);
        this.votes = new VotesStore(this);
        this.documents = new DocumentStore(this);
        this.war = new WARStore(this);
        this.alert = new AlertStore(this);
        this.conn = new ConnectionStore(this);
        this.tasks = new TasksStore(this);
    }
}
let store = new Store();

if (window.offlineApiExtension) {
    window.offlineApiExtension.set('store', store);
}

 window.store = store;
export default store;



// WEBPACK FOOTER //
// ./src/stores/store.js